import React from 'react';
import '../styles/ServiceDetails.css';

function ServiceStudies() {
  return (
    <div className="page">

      <section className="hero">
        <div className="hero-inner">
          <h1 className="title">Μελέτες για Τεχνικά Έργα</h1>
          <p className="subtitle">Technical Studies</p>
        </div>
      </section>

      <section className="intro">
        <div className="wrap">
          <p>
            Η ΚΑΡΤΕΡΙΑ Κατασκευαστική &amp; Συμβουλευτική παρέχει υπηρεσίες εκπόνησης,
            διοίκησης και τεχνικού ελέγχου μελετών για τεχνικά έργα, με στόχο τη θεσμικά
            ορθή ωρίμανση, την τεχνική πληρότητα και τη δυνατότητα άμεσης και ασφαλούς
            υλοποίησης.
          </p>
          <p>
            Η μελετητική διαδικασία αντιμετωπίζεται ως καθοριστικό στάδιο του έργου, στο
            οποίο τεκμηριώνεται η σκοπιμότητα, διασφαλίζεται η κανονιστική συμμόρφωση και
            δημιουργούνται οι προϋποθέσεις για ομαλή αδειοδότηση, χρηματοδότηση και
            κατασκευή.
          </p>
        </div>
      </section>

      <section className="services">
        <div className="wrap">
          <h2 className="heading">Αντικείμενο Υπηρεσιών</h2>
          <p className="lead">Οι υπηρεσίες μελετών για τεχνικά έργα περιλαμβάνουν:</p>

          <ul className="list">
            <li>Εκπόνηση και συντονισμό μελετών σε όλα τα απαιτούμενα στάδια ωρίμανσης.</li>
            <li>Έλεγχο πληρότητας, συνοχής και κανονιστικής συμβατότητας των μελετών.</li>
            <li>Εκπόνηση, έλεγχο και συντονισμό αρχιτεκτονικών και οικοδομικών μελετών.</li>
            <li>Εκπόνηση και έλεγχο στατικών και γεωτεχνικών μελετών.</li>
            <li>Εκπόνηση και έλεγχο υδραυλικών μελετών και μελετών έργων υποδομής.</li>
            <li>Εκπόνηση και έλεγχο ηλεκτρομηχανολογικών μελετών (Η/Μ εγκαταστάσεων).</li>
            <li>Εκπόνηση μελετών οδοποιίας, κυκλοφοριακών και λοιπών ειδικών τεχνικών μελετών, ανάλογα με το αντικείμενο και τις προδιαγραφές του έργου.</li>
            <li>Εκπόνηση περιβαλλοντικών μελετών, περιβαλλοντικών τεκμηριώσεων και μελετών διαμόρφωσης πρασίνου και περιβάλλοντος χώρου, όπου απαιτούνται από το θεσμικό πλαίσιο του έργου.</li>
            <li>Εκπόνηση ενεργειακών μελετών και τεχνικών αξιολογήσεων ενεργειακής απόδοσης.</li>
            <li>Σύνταξη προμετρήσεων και τευχών δημοπρασίας σε Δημόσια και Ιδιωτικά έργα.</li>
            <li>Τεκμηρίωση τεχνικών, λειτουργικών και ποιοτικών απαιτήσεων του έργου.</li>
            <li>Σύνταξη τεχνικών εκθέσεων και υποστηρικτικών μελετητικών φακέλων.</li>
            <li>Υποστήριξη στη διαδικασία αδειοδότησης και στις απαιτούμενες εγκρίσεις.</li>
          </ul>

          <p className="sublead">
            Στο πλαισιο της ωριμανσης και χρηματοδοτικης προετοιμασιας εργων, παρεχονται επιπλεον:
          </p>
          <ul className="list list-alt">
            <li>Εκπόνηση μελετών σκοπιμότητας, βιωσιμότητας και προσβασιμότητας</li>
            <li>Σύνταξη Τεχνικών Δελτίων για υποβολή μελών σε πρόσκληση Ευρωπαϊκών προγραμμάτων (ΕΕ / ΕΣΠΑ)</li>
            <li>Τεκμηρίωση φυσικού αντικειμένου, χρονοδιαγράμματος και βασικών τεχνικών, περιβαλλοντικών και ενεργειακών παραμέτρων, σύμφωνα με τις απαιτήσεις των εκάστοτε προγραμμάτων</li>
          </ul>
        </div>
      </section>

      <section className="iso">
        <div className="wrap">
          <h2 className="heading">Πλαίσιο Οργάνωσης και Ποιοτικής Προσέγγισης</h2>
          <p className="lead">
            Η εκπόνηση και ο έλεγχος των μελετών οργανώνονται βάσει δομημένων διαδικασιών,
            με στόχο τη συνέπεια, την τεχνική πληρότητα και τη δυνατότητα εφαρμογής των
            μελετών στην υλοποίηση.
          </p>
          <p className="lead">
            Στο πλαίσιο αυτό, η μελετητική διαδικασία βασίζεται στις αρχές των
            ακόλουθων διεθνών προτύπων:
          </p>
          <div className="iso-grid">
            <div className="iso-card">
              <div className="badge">ISO 9001</div>
              <p>Εφαρμόζεται ως πλαίσιο οργάνωσης και ελέγχου της ποιότητας των μελετητικών παραδοτέων, με υποστήριξη μέσω Προγράμματος Ποιότητας Έργου (ΠΠΕ), διασφαλίζοντας τη συνέπεια, την πληρότητα και την τεκμηρίωση των απαιτήσεων του έργου.</p>
            </div>
            <div className="iso-card">
              <div className="badge">ISO 14001</div>
              <p>Λαμβάνεται υπόψη για την ενσωμάτωση περιβαλλοντικών παραμέτρων στον σχεδιασμό και την τεκμηριωμένη συμμόρφωση με το ισχύον περιβαλλοντικό και κανονιστικό πλαίσιο.</p>
            </div>
            <div className="iso-card">
              <div className="badge">ISO 50001</div>
              <p>Αξιοποιείται για την τεχνική τεκμηρίωση και αξιολόγηση ενεργειακών παραμέτρων και αποδοτικότητας, όπου αυτό απαιτείται από το αντικείμενο της μελέτης.</p>
            </div>
            <div className="iso-card">
              <div className="badge">ISO 45001</div>
              <p>Λαμβάνεται υπόψη στη μελετητική φάση μέσω της συνεκτίμησης θεμάτων Υγείας και Ασφάλειας στην Εργασία, ώστε η εφαρμογή των μελετών στην κατασκευή να πραγματοποιείται με μειωμένο τεχνικό και εργοταξιακό κίνδυνο.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="legal">
        <div className="wrap">
          <h2 className="heading">Θεσμικό και Κανονιστικό Πλαίσιο</h2>
          <p className="lead">
            Οι μελέτες για τεχνικά έργα εκπονούνται σε συμμόρφωση με το ισχύον πολεοδομικό,
            κανονιστικό και τεχνικό πλαίσιο και ιδίως με:
          </p>
          <ul className="list">
            <li><strong>Ν. 4067/2012</strong> (Νέος Οικοδομικός Κανονισμός)</li>
            <li><strong>Ν. 3316/2005</strong> — Ανάθεση και εκτέλεση δημοσίων συμβάσεων εκπόνησης μελετών και παροχής συναφών υπηρεσιών</li>
            <li><strong>Ν. 4495/2017</strong> — για τον έλεγχο και την προστασία του δομημένου περιβάλλοντος</li>
            <li><strong>Ν. 4412/2016</strong> — όπου οι μελέτες αφορούν έργα δημοσίου χαρακτήρα ή έργα που εντάσσονται σε χρηματοδοτικά προγράμματα</li>
          </ul>
          <p className="legal-note">
            Για συγχρηματοδοτούμενα έργα λαμβάνονται υπόψη οι ειδικοί όροι, οδηγοί εφαρμογής
            και απαιτήσεις τεκμηρίωσης των ευρωπαϊκών και εθνικών χρηματοδοτικών προγραμμάτων,
            ώστε οι φάκελοι ένταξης να είναι πλήρεις, θεσμικά συμβατοί και τεχνικά
            τεκμηριωμένοι.
          </p>
        </div>
      </section>

      <section className="approach">
        <div className="wrap">
          <h2 className="heading">Η Προσέγγισή μας</h2>
          <p>
            Οι μελέτες για τεχνικά έργα στην ΚΑΡΤΕΡΙΑ αποτελούν τη βάση της επιτυχημένης
            υλοποίησης, συνδυάζοντας τεχνική επάρκεια, θεσμική συνέπεια και ουσιαστική
            τεκμηρίωση, από το στάδιο της σκοπιμότητας έως την έτοιμη προς κατασκευή λύση.
          </p>
        </div>
      </section>

    </div>
  );
}

export default ServiceStudies;
